/* omw-entrega.js — CHG-011 · Oh My Wood! · v3 · 2026-09-22
   Fecha ÚNICA de entrega + cuenta atrás al cierre.

   QUÉ CAMBIA FRENTE A v2 (CHG-007) y POR QUÉ:

   1. Una sola fecha, no un rango. El rango «entre el martes y el jueves»
      transmitía inseguridad. Ahora se promete la fecha MÁXIMA y punto.
   2. La promesa es 72 h TOTALES, no producción + envío por separado. Ese
      desglose era un invento: el banner de la tienda siempre ha dicho 24-48 h
      incluyendo fabricación y transporte. Un único parámetro: data-dias.
   3. «o antes» en lugar de «antes del». Si la fecha máxima es el jueves,
      «antes del jueves» promete el miércoles y te deja en falta justo el día
      que sí cumplías.

   SE MANTIENE DE v2 (y conviene no tocarlo):
   - El reloj es el de BAENA, no el del navegador. Sin esto un cliente canario
     veía un día laborable de menos entre las 13:00 y las 14:00 peninsulares,
     y los viernes, el fin de semana entero.
   - Festivos, incluidos los locales de Baena.
   - Lista con caducidad: al expirar cae a un texto sin fecha en vez de mentir.
   - El nodo se re-consulta en cada pasada y el observer se registra UNA vez,
     porque Teeinblue rehace esta zona del DOM al montar el personalizador. */
(function () {
  'use strict';

  var TZ = 'Europe/Madrid';
  var fmt = null;
  try {
    fmt = new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    });
  } catch (e) { fmt = null; }

  function ahoraBaena() {
    if (!fmt) return null;
    var p = {};
    fmt.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    var h = p.hour === '24' ? 0 : Number(p.hour);
    return { y: +p.year, m: +p.month, d: +p.day, h: h, mi: +p.minute, s: +p.second };
  }

  var timer = null;
  var observer = null;

  function arrancar(caja) {
    if (!caja) return;

    var corte    = Number(caja.getAttribute('data-corte')) || 14;
    var dias     = Number(caja.getAttribute('data-dias')) || 3;
    var txtPre   = caja.getAttribute('data-texto-pre')  || 'Recíbelo el ';
    var txtPost  = caja.getAttribute('data-texto-post') || ' o antes';
    /* Un minificador de HTML puede recortar el espacio final del atributo y
       dejar «Recíbelo eljueves 25». Se normaliza aquí y no se vuelve a pensar. */
    if (txtPre && txtPre.slice(-1) !== ' ') txtPre += ' ';
    if (txtPost && txtPost.charAt(0) !== ' ') txtPost = ' ' + txtPost;
    var caduca   = caja.getAttribute('data-caduca') || '';
    /* CRO-005: el tramo de envío se lee del snippet. Antes estaba escrito aquí dentro
       Y en el Liquid, y como el JS repinta cada segundo, ganaba siempre el JS: cambiar
       el snippet no servía de nada. Un solo sitio para un solo texto. */
    var txtEnvio = caja.getAttribute('data-envio') || '';
    var festivos = (caja.getAttribute('data-festivos') || '')
      .split(',').map(function (x) { return x.trim(); }).filter(Boolean);

    function iso(d) {
      var m = d.getMonth() + 1, dd = d.getDate();
      return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (dd < 10 ? '0' + dd : dd);
    }
    function esLaborable(d) {
      var wd = d.getDay();
      if (wd === 0 || wd === 6) return false;
      return festivos.indexOf(iso(d)) === -1;
    }
    function sumarLaborables(d, n) {
      var dt = new Date(d.getTime()), c = 0;
      while (c < n) { dt.setDate(dt.getDate() + 1); if (esLaborable(dt)) c++; }
      return dt;
    }
    /* Día en que arranca el reloj de las 72 h. Si hoy es laborable y aún no se
       ha pasado el corte, arranca hoy; si no, el siguiente día laborable. */
    function diaInicio(b) {
      var dt = new Date(b.y, b.m - 1, b.d);
      if (esLaborable(dt) && b.h < corte) return dt;
      do { dt.setDate(dt.getDate() + 1); } while (!esLaborable(dt));
      return dt;
    }
    // «jue 25 sep»: sin el mes, a final de mes es ilegible.
    function fecha(d) {
      var wd = d.toLocaleString('es-ES', { weekday: 'long' });
      var mes = d.toLocaleString('es-ES', { month: 'short' }).replace('.', '');
      return wd + ' ' + d.getDate() + ' ' + mes;
    }
    function dosCifras(n) { return n < 10 ? '0' + n : '' + n; }

    function pintar() {
      var viva = document.querySelector('[data-omw-entrega]');
      if (!viva || !viva.isConnected) return;
      var preEl  = viva.querySelector('[data-omw-pre]');
      var etaEl  = viva.querySelector('[data-omw-eta]');
      var postEl = viva.querySelector('[data-omw-post]');
      var subEl  = viva.querySelector('[data-omw-sub]');

      var b = ahoraBaena();
      if (!b) return;                            // sin Intl no se promete nada

      // Lista de festivos caducada → texto sin fecha, nunca una fecha falsa.
      if (caduca && iso(new Date(b.y, b.m - 1, b.d)) > caduca) {
        if (preEl)  preEl.textContent  = 'Recíbelo en ';
        if (etaEl)  etaEl.textContent  = dias + ' días laborables';
        if (postEl) postEl.textContent = '';
        if (subEl && txtEnvio) subEl.innerHTML = txtEnvio;
        viva.classList.add('omw-entrega--listo');
        if (timer) { clearInterval(timer); timer = null; }
        return;
      }

      var inicio  = diaInicio(b);
      var entrega = sumarLaborables(inicio, dias);
      var eta     = fecha(entrega);

      /* Solo textContent sobre nodos fijos. Reescribir el HTML entero destruía
         y recreaba el <strong> una vez por segundo, y eso cancelaba cualquier
         selección de texto del usuario sobre la fecha. */
      if (preEl  && preEl.textContent  !== txtPre)  preEl.textContent  = txtPre;
      if (etaEl  && etaEl.textContent  !== eta)     etaEl.textContent  = eta;
      if (postEl && postEl.textContent !== txtPost) postEl.textContent = txtPost;

      // Segundos hasta el corte, sobre la hora de pared de Baena.
      var hoy = new Date(b.y, b.m - 1, b.d);
      var diasHasta = Math.round((inicio - hoy) / 86400000);
      var resto = (corte * 3600 - (b.h * 3600 + b.mi * 60 + b.s)) + diasHasta * 86400;
      if (resto < 0) resto = 0;
      var hs = Math.floor(resto / 3600), ms = Math.floor((resto % 3600) / 60), ss = resto % 60;

      if (subEl) {
        var reloj = hs >= 24
          ? Math.floor(hs / 24) + 'd ' + dosCifras(hs % 24) + 'h ' + dosCifras(ms) + 'm'
          : (hs >= 1 ? dosCifras(hs) + 'h ' + dosCifras(ms) + 'm'
                     : dosCifras(ms) + 'm ' + dosCifras(ss) + 's');
        var txt = 'Pídelo en las próximas <b>' + reloj + '</b>'
                + (txtEnvio ? ' · ' + txtEnvio : '');
        if (subEl.innerHTML !== txt) subEl.innerHTML = txt;
      }
      viva.classList.add('omw-entrega--listo');
    }

    if (timer) clearInterval(timer);
    /* El primer pintado va DESPUÉS de armar el intervalo y dentro de try/catch:
       una excepción aquí dejaba el módulo muerto, sin observer ni timer. */
    timer = setInterval(pintar, 1000);
    try { pintar(); } catch (e) { /* el texto de respaldo del Liquid sigue siendo válido */ }
  }

  function iniciar() {
    arrancar(document.querySelector('[data-omw-entrega]'));
    // Un solo observer para todo el módulo.
    if (!observer && 'MutationObserver' in window) {
      observer = new MutationObserver(function () {
        var n = document.querySelector('[data-omw-entrega]');
        if (n && !n.classList.contains('omw-entrega--listo')) arrancar(n);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        if (timer) { clearInterval(timer); timer = null; }
      } else {
        arrancar(document.querySelector('[data-omw-entrega]'));
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else { iniciar(); }
})();
